import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BoxService } from '@app/services/boxes/box.service';
import { BoxType } from '@pdqdev/pdq-shared/dist/entities';
import { IBoxSettingsData } from '@pdqdev/pdq-shared/dist/interfaces';
import { tabs } from '../package.model';
import { EditPackageGuardComponent } from './edit-package-guard/edit-package-guard.component';
import { SettingsEditPackageService } from './edit-package.service';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-settings-edit-package',
  templateUrl: './edit-package.component.html',
  styleUrls: ['./edit-package.component.scss'],
  standalone: false,
})
export class SettingsEditPackageComponent implements OnInit {
  @ViewChild('packageContainer') private packageContainer: ElementRef;
  tabs = tabs;
  boxData: IBoxSettingsData;
  boxesData: IBoxSettingsData[];
  unavailableKeyBinds = [];
  isNew = true;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private boxService: BoxService,
    public settingsEditPackageService: SettingsEditPackageService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.boxService
      .getBoxes({ excludeCustomBoxes: true, shouldCheckWritePermissions: true })
      .pipe(
        switchMap((data) => {
          this.boxesData = data;

          return this.route.paramMap.pipe(map((paramMap) => ({ data, paramMap })));
        }),
      )
      .subscribe({
        next: ({ data, paramMap }) => {
          this.boxesData = data;
          const param = paramMap.get('id');
          let tabSelection = 1;
          if (param) {
            this.isNew = false;
            const splitParam = param.split('duplicate-');
            let id;
            let isDuplicate;
            if (splitParam.length === 2) {
              id = splitParam[1];
              isDuplicate = true;
            } else {
              id = splitParam[0];
            }
            this.onTabSelection(-1);
            this.boxData = data.find((x) => x.id === Number(id));

            if (this.boxData) {
              if (isDuplicate) {
                this.boxData.id = null;
                this.boxData.name = `${this.boxData.name} copy`;
              } else if (this.boxData.type === BoxType.FLAT_RATE) {
                tabSelection = 2;
              }
            }
          }
          this.onTabSelection(tabSelection);
          this.setUnavailableKeyBinds();
        },
        error: (error) => {
          if (error.status === 403) {
            this.navigateToPackages();
          }
        },
      });

    this.settingsEditPackageService.loadAssets();
  }

  navigateToPackages() {
    this.router.navigate(['./settings/packages']);
  }

  setUnavailableKeyBinds() {
    this.unavailableKeyBinds = this.boxesData.filter((box) => box.id !== this.boxData?.id).map((box) => box.keybind);
  }

  onTabSelection(item, tabChanged = false) {
    if (tabChanged && this.settingsEditPackageService.formGroup?.dirty) {
      let result: boolean;
      const dialogRef = this.dialog.open(EditPackageGuardComponent, {
        width: '612px',
        height: '188px',
        panelClass: 'padding-0',
      });
      dialogRef.componentInstance?.onLeavePage.subscribe((value) => {
        result = value;
      });
      dialogRef
        .afterClosed()
        .toPromise()
        .then(() => {
          if (result) {
            this.selectTab(item);
          }
        });
    } else {
      this.selectTab(item);
    }
  }

  selectTab(item) {
    if (
      this.boxData?.id &&
      ((this.boxData.type === BoxType.FLAT_RATE && item === 1) ||
        (this.boxData.type !== BoxType.FLAT_RATE && item === 2))
    ) {
      this.settingsEditPackageService.formGroup = null;
      this.boxData = null;
    }
    this.tabs.forEach((t) => (t.active = false));
    if (this.tabs[item - 1]) {
      this.tabs[item - 1].active = true;
    }
  }

  scrollToBottom() {
    setTimeout(() => {
      this.packageContainer.nativeElement.scroll({
        top: this.packageContainer.nativeElement.scrollHeight,
        left: 0,
        behavior: 'smooth',
      });
    }, 0);
  }
}
